import { render, staticRenderFns } from "./nursingPerson.vue?vue&type=template&id=a0d27b48&scoped=true"
import script from "./nursingPerson.vue?vue&type=script&lang=js"
export * from "./nursingPerson.vue?vue&type=script&lang=js"
import style0 from "./nursingPerson.vue?vue&type=style&index=0&id=a0d27b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d27b48",
  null
  
)

export default component.exports